module.exports = __webpack_public_path__ + "img/red-pita-07.f8cf654f.png";